<template>
  <div>
    <Modal v-model="visible" title="新增产品" width="1300" class="my-modal top" :footer-hide="true" :mask-closable="false">
      <div class="search-box">
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入产品名称" clearable />
        </div>
        <div class="input-item">
          <span class="label">产品编码</span>
          <Input v-model="searchParams.productCode" placeholder="请输入产品编码" clearable />
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" transfer placeholder="请选择保司" clearable filterable>
            <Option v-for="(item, index) in companyList" :value="item.code" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">上架状态</span>
          <Select v-model="searchParams.publishStatus" transfer placeholder="请选择上架状态" clearable>
            <Option value="1">已下架</Option>
            <Option value="2">已上架</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">销售状态</span>
          <Select v-model="searchParams.salesStatus" transfer placeholder="请选择销售状态" clearable>
            <Option value="1">停售</Option>
            <Option value="2">在售</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeOriginSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保司</Radio>
            <Radio label="2">通道</Radio>
          </RadioGroup>
        </div>
        <div v-if="searchParams.supplierType" class="input-item">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option v-for="(item, index) in supplierList" :key="index" :value="item.value">{{ item.label }}</Option>
          </Select>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="searchAjax">查询</Button>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部产品</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >项,共<span>{{ total }}</span
            >款产品</span
          >
        </div>
      </div>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
          <template slot-scope="{ row }" slot="productName">
            <Tooltip class="productName" :content="row.productName">
              <span @click="showEdit(row)">{{ row.productName }}</span>
            </Tooltip>
          </template>
        </Table>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageNumChange" style="text-align: center" />
      </div>

      <div class="footer">
        <div class="footer-btn">
          <Button @click="visible = false">取消</Button>
          <Button type="primary" @click="ok">确定</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  data() {
    return {
      visible: false,
      isAll: false,
      activityId: '',
      columns: [
        {
          type: 'selection',
          width: 100,
          align: 'center'
        },
        {
          title: '产品编码',
          key: 'productCode',
          align: 'center',
          width: 100
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          slot: 'productName',
          width: '400'
        },
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center'
        },
        {
          title: '供应商',
          key: 'supplierName',
          align: 'center'
        },
        {
          title: '业务类别',
          key: 'sellType',
          align: 'center',
          render(h, params) {
            if (params.row.sellType.indexOf('1') != -1) {
              return <Tag color="blue">网销</Tag>;
            } else if (params.row.sellType.indexOf('3') != -1) {
              return <Tag color="blue">经代</Tag>;
            }
          }
        },
        {
          title: '上架状态',
          slot: 'publishStatus',
          align: 'center',
          render(h, params) {
            if (params.row.publishStatus == 2) {
              return <Tag color="blue">上架</Tag>;
            } else {
              return <Tag color="red">下架</Tag>;
            }
          }
        },
        {
          title: '销售状态',
          slot: 'salesStatus',
          align: 'center',
          render(h, params) {
            if (params.row.salesStatus == 2) {
              return <Tag color="blue">在售</Tag>;
            } else {
              return <Tag color="red">停售</Tag>;
            }
          }
        }
      ],
      selectArr: [],
      supplierList: [],
      companyList: []
    };
  },

  methods: {
    open(activityId) {
      this.visible = true;
      this.activityId = activityId;
      this.searchParams = {};
      this.searchAjax();
      this.queryInsuranceCompanyList();
    },

    searchAjax() {
      this.pageNum = 1;
      this.selectArr = [];
      this.getList();
    },

    changeOriginSupplierType(value) {
      this.searchParams.supplierIds = [];
      if (!value) {
        this.supplierList = [];
        return;
      }
      this.$http({
        url: value == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (value) {
          this.supplierList = res.data.map(i => {
            return {
              value: i.id,
              label: i.name
            };
          });
        } else {
          this.supplierList = [];
        }
      });
    },

    // 查询签约保司
    queryInsuranceCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/list',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/merchantActivity/queryProductConfigList',
        type: 'POST',
        data: {
          pageSize: this.pageSize,
          pageNo: this.pageNum,
          activityId: this.activityId,
          queryConfigProduct: false,
          ...this.searchParams
        }
      }).then(res => {
        res.data.records.forEach(item => {
          this.selectArr.forEach(item2 => {
            if (item.productCode == item2.productCode) {
              item._checked = true;
            }
          });
          if (this.isAll) {
            item._checked = true;
            item._disabled = true;
          }
        });
        this.total = res.data.total;
        this.tableData = res.data.records;
        this.listLoading = false;
      });
    },

    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.productCode); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.productCode); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.productCode) && !selectIds.includes(item.productCode)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.productCode);
        } else if (!ids.includes(item.productCode) && selectIds.includes(item.productCode)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.productCode), 1);
          selectIds.splice(selectIds.indexOf(item.productCode), 1);
        }
      });
    },

    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },

    ok() {
      if (this.listLoading) {
        return;
      }
      if (!this.selectArr.length && !this.isAll) {
        this.$notice.msg('请至少选择一个产品');
        return;
      }
      this.listLoading = true;
      let data = {};
      if (this.isAll) {
        data = {
          activityId: this.activityId,
          isAll: true,
          query: {
            ...this.searchParams
          }
        };
      } else {
        data = {
          activityId: this.activityId,
          productCodeList: this.selectArr.map(item => item.productCode)
        };
      }
      this.$http({
        url: '/buz/merchantActivity/saveProductMainConfig',
        type: 'POST',
        data
      })
        .then(res => {
          this.listLoading = false;
          this.$notice.success('操作成功');
          this.$emit('success');
          this.visible = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    showEdit(row = {}) {
      this.openPageTabTags('/productResource/productManager/productDetail', {
        id: row.productId,
        code: row.productCode,
        isCopy: row.isCopy,
        timeStr: new Date().getTime()
      });
    },

    pageNumChange(value) {
      this.pageNum = value;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.productName {
  width: 100%;
  > .ivu-tooltip-rel {
    width: 100%;
    > span {
      width: 100%;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
      cursor: pointer;
      color: #236dff;
      text-decoration: underline;
    }
  }
}
.footer {
  height: 80px;
  width: 94.5%;
  background: #fff;
  position: relative;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .footer-btn {
    .ivu-btn {
      min-width: 100px;
      margin-right: 10px;
    }
  }
}
</style>
